/**
 * Recherche d'une nouvelle version de l'application.
 *
 * `registerType: 'autoUpdate'` ne vérifie qu'au chargement de la page. Sur un téléphone où
 * l'application installée reste ouverte des jours, elle ne regarde donc jamais : l'utilisateur
 * appuyait sur « Actualiser » — qui ne rafraîchit que les données — et ne voyait aucune des
 * nouvelles fonctions. D'où trois déclencheurs : le bouton, le retour à l'application, et une
 * vérification périodique.
 *
 * Quand une version neuve est trouvée, elle s'active (skipWaiting) et réclame l'onglet, ce qui
 * déclenche « controllerchange » dans main.tsx et le rechargement.
 */
let enregistrement: ServiceWorkerRegistration | undefined

export function memoriserEnregistrement(valeur: ServiceWorkerRegistration | undefined) {
  enregistrement = valeur
}

/**
 * Demande au navigateur de comparer le service worker installé à celui du serveur. Ne rend rien :
 * s'il y a du neuf, le rechargement suit tout seul ; sinon rien ne se passe visiblement.
 */
export async function chercherNouvelleVersion() {
  if (!enregistrement) {
    return
  }

  try {
    await enregistrement.update()
  } catch {
    // Hors ligne, ou serveur injoignable : ce n'est pas une erreur à remonter. On réessaiera au
    // prochain déclencheur.
  }
}

/** Vérifie au retour dans l'application, et toutes les trente minutes tant qu'elle est ouverte. */
export function surveillerLesVersions() {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      void chercherNouvelleVersion()
    }
  })

  // Trente minutes : assez rare pour ne pas peser, assez fréquent pour qu'un déploiement du
  // matin soit pris avant le soir.
  setInterval(() => void chercherNouvelleVersion(), 30 * 60 * 1000)
}
